import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { TuiSizeL, TuiSizeM, TuiSizeS } from '@taiga-ui/core';
import { ViewMode } from '@src/models';

/**
 * Ищем в строке ссылки или почтовый адрес и даем пользователю возможность по ним перейти
 * */
@Component({
  selector: 'app-field-parse-links',
  templateUrl: './field-parse-links.component.html',
  styleUrls: ['./field-parse-links.component.scss', '../styles/field-content.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldParseLinksComponent {
  @Input() mode?: ViewMode = 'view';

  @Input() size: TuiSizeS | TuiSizeM | TuiSizeL = 'l';

  @Input() name?: string;

  @Input() value: string | null = null;

  @Input() noUnderline?: boolean = false;
}
